module.exports = __webpack_public_path__ + "static/c07a5a7d89a569fd2f5a7dc8873236e35c738ef6c5525db9e8e619938f67f5f7-cca4053a47e5ac1d1def540151ad81b1.jpeg";